module.exports = __webpack_public_path__ + "img/1 (147).1a3fa914.png";